<template>
  <div class="Foot-area">
    <div class="foot-top">
      <div class="tip">免费咨询电话</div>
      <div class="phone">
        <a href="tel:4006771996">400-677-1996</a>
        <a href="tel:17746996888">17746996888</a>
      </div>
      <div class="address-link dis_flex">
        <div class="address">地址：河南省许昌市襄城县紫云镇工业园区</div>
        <div class="links dis_flex flex_wrap dis_jucont_end">
          <span>友情链接：</span>
          <a
            :href="link.url"
            target="_blank"
            v-for="link in linkList"
            :key="link.id"
            >{{ link.name }}</a
          >
        </div>
      </div>
    </div>
    <div class="foot-center ewms dis_flex flex_wrap">
      <div
        class="img"
        v-for="(item, index) in [
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/001.png',
            name: '微信视频号'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/002.png',
            name: '快手：面条机',
            tip: 'ID：1653631971'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/004.png',
            name: '快手：馒头机',
            tip: 'ID：mantouji666'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/003.png',
            name: '抖音：面条机',
            tip: 'ID：miantiaoji777'
          },
          {
            img: 'http://wxsmjphoto.wanjiejixie.com/web_img/005.png',
            name: '抖音：馒头机',
            tip: 'ID：mantouji666'
          }
        ]"
        :key="index"
      >
        <img :src="item.img" />
        <div class="title">{{ item.name }}</div>
        <div class="tip" v-if="item.tip">{{ item.tip }}</div>
      </div>
    </div>
    <div class="foot-bottom">
      CORPYRIGHT © 万杰智能科技股份有限公司 All Rights Reserved.
      <a href="http://beian.miit.gov.cn/" target="_blank">豫ICP备10008366号</a>
      <div id="tongji"></div>
    </div>
    <el-backtop :bottom="100" :right="20"></el-backtop>
  </div>
</template>

<script>
export default {
  data() {
    return {
      linkList: []
    };
  },
  mounted() {
    this.$https
      .fetchPost("/api/getfriendship", {})
      .then(res => {
        // console.log(res.data)
        this.linkList = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  components: {}
};
</script>
<style lang="less" scoped>
.Foot-area {
  background-color: rgba(31, 31, 35, 1);
  a:hover {
    color: #22bdc1 !important;
  }
  .foot-top {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: rgba(181, 181, 181, 1);
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    padding: 60px 90px 30px;

    .phone {
      font-family: SFUDINMittelschrift;
      font-size: 32px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 36px;
      letter-spacing: 0px;
      color: rgba(34, 189, 193, 1);
      display: flex;
      a {
        width: 50%;
        display: inline-block;
        color: rgba(34, 189, 193, 1);
      }
    }
    .address-link {
      .address {
        width: 50%;
      }
      .links {
        width: 50%;
        a {
          color: #727272;
          margin-right: 10px;
          display: inline-block;
        }
      }
    }
  }

  .foot-center {
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 30px;
    margin-top: 40px;
    justify-content: space-around;
    flex-wrap: wrap;
    .img {
      width: 33%;
      text-align: center;
      margin-bottom: 15px;
      img {
        margin: 0 auto;
        width: 200px;
        height: 200px;
        // background: #fff;
      }
    }
    .title {
      margin-top: 8px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #727272;
    }
    .tip {
      margin-top: 5px;
      text-align: center;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #727272;
    }
  }
  .foot-bottom {
    text-align: center;
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: rgba(255, 255, 255, 0.2);
    padding: 10px 90px;
    a {
      color: #616162;
      margin-left: 5px;
    }
  }
}

.el-backtop {
  width: 60px;
  height: 60px;
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue